"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { saving: false };
        this.fhandler = new FormHandler({
            key: 'create-app',
            autosave: true
        });
        this.fhandler.bind(this);
    },
    onMount: function () {
        const title = 'Creating App';
        this.fhandler.on('autosave', () => GState.activity.add({
            title,
            path: '/create-app'
        })).on('reset', () => GState.activity.remove(title));
    },
    onSubmit: async function () {
        const Form = newObject(this.state.form);
        if (!Form.type)
            return this.state.formError.type = true;
        if (!Form.name)
            return this.state.formError.name = true;
        if (Form.type == 'WES') {
            if (!Form.requestURL)
                return this.state.formError.requestURL = true;
            if (!Form.eventList)
                return this.state.formError.eventList = true;
            Form.eventList = Form.eventList.split(/\s*,\s*/);
        }
        this.state.saving = true;
        try {
            const {error, message} = await Request('/app/create', 'POST', Form);
            this.state.saving = false;
            this.fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            this.fhandler.reset();
        } catch (error) {
            this.state.saving = false;
            this.fhandler.alert(error);
        }
    },
    onReset: function () {
        this.fhandler.reset();
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Apps/Create.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Bx_template = require("../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Select_template = require("../../../components/Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("175d36"),
    marko_node0 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "42", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "mt-50 text-muted"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_attrs7 = {
        "class": "mt-50 text-muted"
      },
    marko_attrs8 = {
        "class": "form-group"
      },
    marko_attrs9 = {
        "class": "mt-50 text-muted"
      },
    marko_attrs10 = {
        href: "/",
        target: "_blank"
      },
    marko_attrs11 = {
        "class": "col-4 pr-50"
      },
    marko_attrs12 = {
        type: "reset",
        "class": "btn btn-light btn-xl w-100"
      },
    marko_attrs13 = {
        "class": "col pl-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.be("form", null, "@create-app", component);

              out.be("div", marko_attrs0, "2", component);

              Bx_tag({
                  type: "cube-alt",
                  class: "font-large-5"
                }, out, __component, "3");

              out.ee();

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              out.be("div", marko_attrs1, "6", component);

              Select_tag({
                  class: "rounded",
                  size: "xl",
                  value: state.form.type,
                  name: "type",
                  options: [
                      {
                          value: "WES",
                          label: "Webhook Event Subscription"
                        },
                      {
                          value: "CloudDB",
                          label: "Cloud Database Service"
                        }
                    ],
                  placeholder: Locale("Service Type")
                }, out, __component, "7", [
                [
                  "select",
                  "__onChange",
                  false
                ]
              ]);

              out.ee();

              out.be("div", marko_attrs2, "8", component);

              out.e("input", {
                  type: "text",
                  value: state.form.name,
                  name: "name",
                  "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.name != undefined ? state.formError.name ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("Name")
                }, "9", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2 " + (!state.formError.name ? " d-none" : ""))
                }, "10", component, null, 1);

              Locale_tag({
                  text: "App name is required"
                }, out, __component, "11");

              out.ee();

              out.ee();

              out.e("div", marko_attrs3, "12", component, 1)
                .e("textarea", {
                    type: "text",
                    value: state.form.description,
                    name: "description",
                    "class": marko_classValue("form-control form-control-xl pl-4 " + (state.formError.description != null ? state.formError.description ? " is-invalid" : " is-valid" : "")),
                    placeholder: Locale("Description*"),
                    validate: "required",
                    style: marko_styleValue({
                        height: "100px",
                        resize: "none"
                      })
                  }, "13", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

              if (state.form.type == "WES") {
                out.be("div", marko_attrs4, "14", component);

                out.e("input", {
                    type: "url",
                    value: state.form.requestURL,
                    name: "requestURL",
                    "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.requestURL != undefined ? state.formError.requestURL ? " is-invalid" : " is-valid" : "")),
                    validate: "required url",
                    placeholder: Locale("Request URL")
                  }, "15", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

                out.be("p", {
                    "class": marko_classValue("small mt-50 mb-2 " + (!state.formError.requestURL ? " d-none" : ""))
                  }, "16", component, null, 1);

                Locale_tag({
                    text: "Invalid URL"
                  }, out, __component, "17");

                out.ee();

                out.be("p", marko_attrs5, "18", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Enter complete URL of the server where Events notification should be delivered to.");
                    }
                  }, out, __component, "19");

                out.ee();

                out.ee();

                out.be("div", marko_attrs6, "20", component);

                out.e("input", {
                    type: "url",
                    value: state.form.eventTarget,
                    name: "eventTarget",
                    "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.eventTarget != undefined ? state.formError.eventTarget ? " is-invalid" : " is-valid" : "")),
                    placeholder: Locale("Event Target")
                  }, "21", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

                out.be("p", marko_attrs7, "22", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Unique Token or name of targeted event scope");
                    }
                  }, out, __component, "23");

                out.ee();

                out.ee();

                out.be("div", marko_attrs8, "24", component);

                out.e("input", {
                    type: "text",
                    value: state.form.eventList,
                    name: "eventList",
                    "class": marko_classValue("form-control form-control-xl pl-4" + (state.formError.eventList != undefined ? state.formError.eventList ? " is-invalid" : " is-valid" : "")),
                    validate: "required",
                    placeholder: Locale("Event List")
                  }, "25", component, 0, 0, {
                    onchange: __component.d("change", "__onChange", false)
                  });

                out.be("p", marko_attrs9, "26", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Enter the list of event you are subscribing for by seperating them with comma (,). Check ");
                    }
                  }, out, __component, "27");

                out.t(" ");

                out.be("a", marko_attrs10, "28", component);

                Locale_tag({
                    text: "Webhook Event Subscription"
                  }, out, __component, "29");

                out.ee();

                out.t(" ");

                Locale_tag({
                    renderBody: function(out) {
                      out.t("for more information.");
                    }
                  }, out, __component, "30");

                out.ee();

                out.ee();
              }

              out.n(marko_node2, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "32");

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs11, "34", component);

                    out.be("button", marko_attrs12, "35", component, null, 0, {
                        onclick: __component.d("click", "onReset", false)
                      });

                    Locale_tag({
                        text: "Reset"
                      }, out, __component, "36");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs13, "37", component);

                    out.be("button", {
                        type: "submit",
                        "class": "btn btn-primary btn-xl w-100",
                        disabled: state.saving
                      }, "38", component, null, 0, {
                        onclick: __component.d("click", "onSubmit", false)
                      });

                    Preloader_tag({
                        class: "float-right font-medium-5",
                        active: state.saving
                      }, out, __component, "39");

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "40");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "33");

              out.n(marko_node3, component);

              out.n(marko_node4, component);

              out.ee();
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
